export { default } from './BlogMainPage';
